import { ExposureRequest } from "./exposureRequest.model";

export class MappingHistory {
  id: string;
  timestamp: number;
  mappingGroupId: string;
  parameterId: string;
  mapResultKmlFileName: string;
  mapResultKmlFileUrl: string;
  zonedResultKmlFileName: string;
  zonedResultKmlFileUrl: string;
  organizationLevelId: string;
  currDate?: string;
  shortDate?: string;
  currTime?: string;
}

export class MappingHistoryPayload extends ExposureRequest {
  mappingGroupId: string;
}
